// Generated by ts-to-zod
import { z } from 'zod';
import { idSchema, urlSchema } from '../../utils/codecUtils.schema';

export const queueActionSchema = z.object({
  type: z.string(),
  event: z
    .union([
      z.literal('annotation_imported'),
      z.literal('annotation_import_succeeded'),
      z.literal('annotation_import_failed'),
      z.literal('annotation_confirmed'),
      z.literal('annotation_exported'),
      z.literal('annotation_export_succeeded'),
      z.literal('annotation_export_failed'),
      z.literal('validation'),
    ])
    .optional(),
  payload: z.unknown().optional(),
});

export const queueRuleActionSchema = queueActionSchema.extend({
  id: z.string(),
  enabled: z.boolean(),
});

export const queueRuleSchema = z.object({
  id: idSchema,
  url: urlSchema,
  enabled: z.boolean(),
  name: z.string(),
  description: z.string(),
  queues: z.array(urlSchema),
  triggerCondition: z.string(),
  triggerConditionSummary: z.string().optional(),
  actions: z.array(queueRuleActionSchema),
});
